import { INewbuildingInfo } from '../../types/newbuildingInfo';
import { TReduxActions } from '../../types/redux';

export const defaultNewbuildingInfoState: INewbuildingInfo = {
  fromDeveloperPropsCount: 0,
  newbuildingId: -1,
  newbuildingName: '',
  newbuildingNameFormatted: '',
  rating: 0,
  sections: [],
  newbuildingPath: '',
  reviewsCount: 0,
  reviewDescription: [],
  questionsCount: 0,
  questionsCountText: '',
  reviewsCountText: '',
  ratingText: '',
  mlReview: null,
  seoData: {
    h1: '',
    title: '',
    description: '',
    location: '',
  },
};

/* oxlint-disable-next-line typescript/no-unused-vars */
export function newbuildingInfoReducer(state: INewbuildingInfo = defaultNewbuildingInfoState, action: TReduxActions) {
  return state;
}
